import React, { useEffect, useState } from 'react';
import { Collapse, Table, Tag, Descriptions, Button, Card, Typography } from 'antd';
import dayjs from 'dayjs';
import { InvoiceService } from '../../../../Services/Manage/InvoiceService';
import { useNavigate } from 'react-router-dom';

const { Panel } = Collapse;

const ProjectMapping = () => {
    const [data, setData] = useState([]);
    const navigate = useNavigate();

    const getMapInvoiceProject = async () => {
        try {
            const request = await InvoiceService.getInvoiceProjectMap();
            setData(request.data);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        getMapInvoiceProject();
    }, []);

    const columns = [
        { title: 'Project No', dataIndex: 'pro_no', key: 'pro_no' },
        { title: 'Name', dataIndex: 'pro_name', key: 'pro_name' },
        { title: 'Description', dataIndex: 'pro_description', key: 'pro_description' },
        { title: 'Department', dataIndex: 'pro_department', key: 'pro_department', align: 'center' },
        { title: 'Start Date', dataIndex: 'pro_start_date', key: 'pro_start_date', render: (text) => dayjs(text).format('YYYY-MM-DD') },
        { title: 'Target End Date', dataIndex: 'pro_target_end_date', key: 'pro_target_end_date', render: (text) => dayjs(text).format('YYYY-MM-DD') },
        { title: 'Requirements', dataIndex: 'pro_requirements', key: 'pro_requirements' },
        {
            title: 'Status',
            dataIndex: 'pro_status',
            key: 'pro_status',
            render: (text) => (
                <Tag style={{ fontSize: '16px', padding: '6px 12px' }} color={
                    text === 'Pending' ? 'orange' :
                        text === 'Live' ? 'green' :
                            text === 'Completed' ? 'blue' :
                                text === 'In Progress' ? 'cyan' : 'default'
                }>
                    {text}
                </Tag>
            ),
        },
        { title: 'Comment', dataIndex: 'pro_comment', key: 'pro_comment', render: (text) => text || '-' },
    ];

    return (
        <div style={{ margin: '0 auto' }}>
            <Card title={
                <Typography.Title level={4}>
                    Invoice and projects
                </Typography.Title>
            }>
            <Collapse accordion>
                {data.map((invoice) => (
                    <Panel
                        key={invoice.id}
                        header={
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <span>
                                Invoice #{invoice.invoice_no}{" "}
                                <Tag color="red" >Status :{invoice.status}</Tag>

                                 <Tag color="blue">Project Count: {invoice.projects?.length || 0}</Tag>

                            </span>
                            </div>
                        }
                        extra={
                            <Button
                                type='primary'
                                onClick={(e) => {
                                    e.stopPropagation(); // prevent collapse toggle
                                    navigate('/invoice/view', { state: { id: invoice.qu_no } });
                                }}
                            >
                                View Invoice
                            </Button>
                        }
                    >
                        <Descriptions  column={2} style={{ marginBottom: 16 }}>
                            <Descriptions.Item label="Invoice No">{invoice.invoice_no}</Descriptions.Item>
                            <Descriptions.Item label="Quotation No">{invoice.qu_no}</Descriptions.Item>
                            <Descriptions.Item label="Status">{invoice.status}</Descriptions.Item>
                            <Descriptions.Item label="Invoice Date">{dayjs(invoice.invoice_date).format('YYYY-MM-DD')}</Descriptions.Item>
                            <Descriptions.Item label="Added By">{invoice.added_by}</Descriptions.Item>
                            <Descriptions.Item label="Added On">{dayjs(invoice.added_on).format('YYYY-MM-DD HH:mm')}</Descriptions.Item>
                            <Descriptions.Item label="Updated On">{dayjs(invoice.updated_on).format('YYYY-MM-DD HH:mm')}</Descriptions.Item>
                        </Descriptions>

                        <h3 style={{ marginBottom: 16 }}>Projects</h3>
                        <Table
                            scroll={{ x: 'max-content' }}
                            columns={columns}
                            dataSource={invoice.projects}
                            rowKey="id"
                            pagination={false}
                        />
                    </Panel>
                ))}
            </Collapse>
            </Card>
        </div>
    );
};

export default ProjectMapping;
